<div class="kretanje-cijena-section">
  <!-- Filters -->
  <div class="filters-card">
    <div class="filters-header">
      <h3>Filteri za kretanje cijena</h3>
    </div>

    <form [formGroup]="filterForm" class="filters-form">
      <div class="filter-row">
        <div class="filter-field">
          <label>Država</label>
          <dx-select-box formControlName="drzava" [dataSource]="drzavaOptions" displayExpr="text" valueExpr="value"
            placeholder="Odaberite državu">
          </dx-select-box>
        </div>

        <div class="filter-field">
          <label>Datum od</label>
          <dx-date-box formControlName="dateFrom" type="date" displayFormat="dd.MM.yyyy" placeholder="Datum od">
          </dx-date-box>
        </div>

        <div class="filter-field">
          <label>Datum do</label>
          <dx-date-box formControlName="dateTo" type="date" displayFormat="dd.MM.yyyy" placeholder="Datum do">
          </dx-date-box>
        </div>

        <div class="filter-field">
          <label>Artikl</label>
          <dx-select-box formControlName="artikal" [dataSource]="artikli" displayExpr="artikl1" valueExpr="id"
            placeholder="Odaberite artikl" [searchEnabled]="true" (onValueChanged)="onArtiklChange($event)">
          </dx-select-box>
        </div>
      </div>

      <!-- New Opisi Row -->
      <div class="filter-row">
        <div class="filter-field opis-field">
          <label>Opisi (opciono)</label>
          <dx-tag-box [dataSource]="opisi" displayExpr="opis" valueExpr="id" placeholder="Odaberite opise"
            [searchEnabled]="true" [value]="selectedOpisi" (onValueChanged)="onOpisChange($event)">
          </dx-tag-box>
          <small class="hint">Ako ne odaberete nijedan opis, biće korišteni svi opisi</small>
        </div>
      </div>

      <div class="filter-actions">
        <dx-button text="Pretraži" type="default" icon="search" (onClick)="onSearch()"
          [disabled]="loading || !filterForm.valid">
        </dx-button>
      </div>
    </form>
  </div>

  <!-- Chart -->
  <div class="chart-card" *ngIf="chartData.length > 0">
    <div class="chart-header">
      <h3>Grafikon kretanja cijena - {{ getArtiklName(selectedArtiklId) }}</h3>
      <span class="opisi-info" *ngIf="selectedOpisi.length > 0">
        (Opisi: {{ getOpisNames(selectedOpisi) }})
      </span>
    </div>

    <dx-chart #chart id="chart" [dataSource]="chartData" palette="Violet">

      <dxo-common-series-settings argumentField="date" type="line">
      </dxo-common-series-settings>

      <dxi-series valueField="min" name="Minimalna cijena">
      </dxi-series>

      <dxi-series valueField="avg" name="Prosječna cijena">
      </dxi-series>

      <dxi-series valueField="max" name="Maksimalna cijena">
      </dxi-series>

      <dxo-argument-axis argumentType="datetime">
        <dxo-label format="dd.MM.yyyy"></dxo-label>
      </dxo-argument-axis>

      <dxo-value-axis [title]="{ text: yAxisTitle }">
      </dxo-value-axis>

      <dxo-legend verticalAlignment="bottom" horizontalAlignment="center">
      </dxo-legend>

      <dxo-export [enabled]="true"></dxo-export>

      <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip">
      </dxo-tooltip>
    </dx-chart>
  </div>

  <!-- Data Table -->
  <div class="data-card" *ngIf="chartData.length > 0">
    <div class="data-header">
      <h3>Podaci o cijenama - {{ getArtiklName(selectedArtiklId) }}</h3>
      <span class="opisi-info" *ngIf="selectedOpisi.length > 0">
        (Opisi: {{ getOpisNames(selectedOpisi) }})
      </span>
    </div>

    <dx-data-grid [dataSource]="chartData" [showBorders]="true" [paging]="{ pageSize: 10 }"
      [pager]="{ showInfo: true }">

      <dxi-column dataField="date" caption="Datum" dataType="date" format="dd.MM.yyyy" [width]="120">
      </dxi-column>

      <dxi-column dataField="min" caption="Min cijena" dataType="number" format="#,##0.00" [width]="120">
      </dxi-column>

      <dxi-column dataField="avg" caption="Prosječna cijena" dataType="number" format="#,##0.00" [width]="140">
      </dxi-column>

      <dxi-column dataField="max" caption="Max cijena" dataType="number" format="#,##0.00" [width]="120">
      </dxi-column>

      <dxi-column caption="Valuta" [calculateCellValue]="getValutaThing" [width]="100">
      </dxi-column>
    </dx-data-grid>
  </div>

  <dx-load-panel [visible]="loading" [showIndicator]="true" [showPane]="true" shadingColor="rgba(0, 0, 0, 0.4)">
  </dx-load-panel>
</div>